export default __webpack_public_path__ + "static/xstackintegration1-b7b860181a7651cd2154f2a9b3f5c430.webp";